module.exports = __webpack_public_path__ + "static/media/AvenirNext-Bold.66e2c443.woff2";